import React from 'react'

export const ContrastLogo = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 890.8 172"
  >
    <path
      className="st0"
      d="M60.9,86.2c0,26.2,10.1,49.4,26.7,65.1c-2.6,0.2-5.3,0.4-8.1,0.4C32.5,151.7,0,124.5,0,87.4
	s32.5-64.3,79.4-64.3c1.9,0,3.7,0,5.4,0.1C69.8,38.9,60.9,61.4,60.9,86.2z"
    />
    <path
      className="st0"
      d="M265,88.5c0-37.4,25.2-67.8,66.4-67.8c14.5,0,27,3.8,35.4,9.7c1.6,1.3,2,2.5,2,4.7v12c0,1.8-0.9,2.9-2.3,2.9
	c-0.9-0.1-1.7-0.5-2.3-1.1c-8.2-7.9-20.2-12.5-32.8-12.5c-30.4,0-47.1,21.1-47.1,51.6c0,31.5,19.2,51,45.8,51
	c13.6,0,24.3-3.4,34.4-11.6c0.6-0.5,1.4-0.8,2.1-0.9c1.3,0.1,2.2,1.1,2.2,2.4c0,0,0,0.1,0,0.1v9.5c0.2,1.6-0.6,3.1-2,3.9
	c-10.4,7.7-22,11.3-40.1,11.3C290.6,153.5,265,126.8,265,88.5z"
    />
    <path
      className="st0"
      d="M467.3,107.1c0,23.1-13.6,46.4-43.1,46.4c-29.4,0-43.3-23.3-43.3-46.4c0-22.9,14-45.3,43.3-45.3
	C453.7,61.9,467.3,84.2,467.3,107.1z M450,107.5c0-19-7.7-33.5-25.8-33.5c-18.3,0-25.8,14.9-25.8,33.5c0,18.8,7.7,34.2,25.8,34.2
	C442.5,141.7,450,126.1,450,107.5L450,107.5z"
    />
    <path
      className="st0"
      d="M493.3,64.9c0.9,0,1.4,0.9,1.6,1.6c0.7,5.6,1,11.2,1.1,16.8c4.8-12.5,17.9-21.5,34.4-21.5
	c15.4,0,27.7,9.5,27.7,27.9v59.8c-0.1,0.8-0.8,1.5-1.6,1.6h-13.1c-0.9-0.1-1.6-0.7-1.6-1.6v-56c0-13.1-6.8-18.6-17.5-18.6
	c-13.4,0-26.1,9.8-26.1,27.2v47.4c-0.1,0.8-0.8,1.5-1.6,1.6h-13.1c-0.9-0.1-1.6-0.7-1.6-1.6V80.8c0-9.3-1.3-13.1-1.3-14.3
	c0-0.8,0.6-1.5,1.4-1.6L493.3,64.9z"
    />
    <path
      className="st0"
      d="M592.4,44.5c0.3-0.9,1.2-1.5,2.1-1.4c1-0.1,2,0.6,2.1,1.6c0,0.2,0,0.4,0,0.5v5.4c-0.1,5-0.5,9.9-1.3,14.9
	c4.8-0.4,14.1-0.5,20.8-0.5c0.7,0,1.3,0.5,1.3,1.6v9.3c0,0.9-0.4,1.4-1.3,1.4c-6.3,0-14.5,0-20.8-0.5c0.5,5.2,0.5,10.4,0.5,19.9V125
	c0,11.5,5.5,15,13.1,15c2.2,0.1,4.3-0.3,6.3-1.3c1.3-0.5,2.1,0,2.1,1.1v10.7c0,0.9-0.7,1.7-1.6,1.8c-3,0.7-6.1,1-9.1,1.1
	c-14.9,0-27-8.9-27-28.1V96.6c-0.1-6.6,0.2-13.3,0.9-19.9c-3.6,0.4-7.3,0.6-10.9,0.5c-1.1,0-1.8-1.3-1.8-3.4c0-2,0.2-3,1.3-3.6
	C578.3,64.5,586.2,55.6,592.4,44.5z"
    />
    <path
      className="st0"
      d="M668.2,76.9c-12.2,0-18.6,12.2-18.6,25.8v46.9c-0.1,0.8-0.8,1.5-1.6,1.6h-13.1c-0.9-0.1-1.6-0.7-1.6-1.6V80.8
	c0-9.3-1.3-13.1-1.3-14.3c0-0.8,0.6-1.5,1.4-1.6h11.3c0.9,0,1.4,0.9,1.6,1.6c0.8,5.9,1.1,11.8,1.1,17.7
	c4.3-13.1,13.8-22.4,26.8-22.4c11.3,0,16.1,5.7,16.1,12.2c0,5.2-2.7,8.9-7.2,8.9C677.2,83,677.7,76.9,668.2,76.9z"
    />
    <path
      className="st0"
      d="M758.8,88.5c0,10.7-0.9,27.4-0.9,37.2c0,12.5,2.5,19.3,5.2,21.3c0.6,0.5,1,1.3,0.9,2.1c-0.1,1.1-0.9,1.9-2,2
	h-7.9c-2.2,0.2-4.2-1.1-4.8-3.2c-2-3.4-3.4-9.1-3.6-14.9c-5,12.5-15.2,20.4-30.4,20.4c-16.3,0-26.1-9.7-26.1-22.7
	c0-17.9,17.4-32.6,53.7-34.7v-5.9c0-9.8-4.5-15.9-18.1-15.9c-7.5,0-12.7,2.1-15.9,6.1c-2.5,3-4.1,5.5-8.1,5.5c-3.9,0-7-2.3-7-6.8
	c0-6.1,9-17.2,32.2-17.2C750.6,61.9,758.8,73.3,758.8,88.5z M705.1,127.9c0,8.8,6.8,13.4,14.7,13.4c13.8,0,23.1-11.1,23.1-25.1
	v-11.5C715.3,106.8,705.1,116.4,705.1,127.9z"
    />
    <path
      className="st0"
      d="M775,146.3c-0.9-0.7-1.5-1.9-1.4-3v-8.2c0-1.4,0.4-2.3,1.3-2.3c1,0,1.9,0.4,2.5,1.1c6.5,5,14.5,7.7,22.7,7.7
	c11.5,0,17.5-5.5,17.5-12.5c0-9.3-8.4-11.5-20.8-15.8c-11.8-3.9-23.1-10-23.1-26c0-13.4,12-25.4,31.9-25.4c10.4,0,18.3,3,22.6,6.6
	c2.3,2,3,3.6,3,6.1c0,4.5-3,7.5-6.1,7.5c-1.9,0.2-3.7-0.5-5-1.8c-4.8-3.9-9.8-5.9-15.4-5.9c-10.4,0-15.2,5.9-15.2,12.4
	c0,9.1,7.5,11.5,17,14.7c17.4,5.9,26.8,11.6,26.8,26.5c0,15.2-13.4,25.6-33.1,25.6C789,153.5,780.6,150.3,775,146.3z"
    />
    <path
      className="st0"
      d="M865.7,44.5c0.3-0.9,1.2-1.5,2.1-1.4c1-0.1,2,0.6,2.1,1.6c0,0.2,0,0.4,0,0.5v5.4c-0.1,5-0.5,9.9-1.3,14.9
	c4.8-0.4,14.1-0.5,20.8-0.5c0.7,0,1.3,0.5,1.3,1.6v9.3c0,0.9-0.4,1.4-1.3,1.4c-6.3,0-14.5,0-20.8-0.5c0.5,5.2,0.5,10.4,0.5,19.9V125
	c0,11.5,5.5,15,13.1,15c2.2,0.1,4.3-0.3,6.3-1.3c1.3-0.5,2.1,0,2.1,1.1v10.7c0,0.9-0.7,1.7-1.6,1.8c-3,0.7-6.1,1-9.1,1.1
	c-14.9,0-27-8.9-27-28.1V96.6c-0.1-6.6,0.2-13.3,0.9-19.9c-3.6,0.4-7.3,0.6-10.9,0.5c-1.1,0-1.8-1.3-1.8-3.4c0-2,0.2-3,1.3-3.6
	C851.6,64.5,859.5,55.6,865.7,44.5z"
    />
    <path
      className="st0"
      d="M199.4,35.5c2.2,14.3-8.8,26-27.4,26c-28.1,0-33-36.1-87.1-38.4C98.9,8.3,118.5-0.1,139,0c0.4,0,0.8,0,1.3,0
	C171.5,0,197,19.9,199.4,35.5z"
    />
    <path
      className="st0"
      d="M183.2,113.9c7.2,1.4,16.5,6.4,16.5,21.4c0,20.9-32.5,36.4-59.5,36.7H140c-19.5,0.1-38.3-7.3-52.4-20.7
	C135.1,147.3,157.4,108.9,183.2,113.9z"
    />
  </svg>
)
